module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-14.bfbf94e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-14.jpg
// module id = eLtf
// module chunks = 51